import type Device from "../models/Device";

/** The synchronous getter exposes only cached catalog data; load it before taking the PDF snapshot. */
export async function loadDeviceFrontImage(device: Device): Promise<string | undefined> {
  const source = device.frontImage;
  if (source) return source;
  await device.template?.knxProductData.loadFrontImage();
  return device.frontImage;
}
